import { ELEMENT_MESSAGE_TYPES_WITH_REQUIRED_TITLE } from "./constants";
export var isTypeWithinList = function isTypeWithinList() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var value = arguments.length > 1 ? arguments[1] : undefined;
  return typeof value === "string" && !!obj[value.toUpperCase()];
};
export var isTypeHasTitleRequired = function isTypeHasTitleRequired(value) {
  return isTypeWithinList(ELEMENT_MESSAGE_TYPES_WITH_REQUIRED_TITLE, value);
};